exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".zone-card-wrapper {\n    display: flex;\n    align-items: center;\n    border: solid 1px #f3f3f3;\n    padding: 0.5rem;\n    justify-content: space-between;\n    width: 100%;\n    box-sizing: border-box;\n}", ""]);

// exports
